"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hash;
/* eslint-disable no-bitwise */
function hash(text) {
  if (!text) {
    return '';
  }
  let hashValue = 5381;
  let index = text.length - 1;
  while (index) {
    hashValue = hashValue * 33 ^ text.charCodeAt(index);
    index -= 1;
  }
  return (hashValue >>> 0).toString(16);
}